import { Injectable } from '@angular/core';
import { StorageObj } from 'src/interfaces/utility-interfaces';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  static keyUserOrgId = 'userOrgID';
  static keyUserProfileId = 'userProfileID';
  static keyUserRole = 'userRole';
  static keyPreviousUrl = 'previousUrl';
  static keyAccessSites = 'accessSites';

  public storageChange: Subject<StorageObj> = new Subject();

  public setStorageItem(change: StorageObj): void {
    sessionStorage.setItem(change.key, change.value);
    this.storageChange.next(change);
  }

  public getStorageItem(getItem: string): string {
    return sessionStorage.getItem(getItem);
  }
}
